import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${rem("285px")};
  height: ${rem("250px")};
  border: ${rem("1px")} solid #ededed;
  box-shadow: ${rem("0px")} ${rem("0px")} ${rem("20px")} #1c120115;
  background-color: #ffffff;
  align-items: center;

  ${({ type }) =>
    type == "instay" &&
    css`
      width: ${rem("286px")};
      height: ${rem("286px")};
    `}

  ${({ theme }) => theme.tablet`
      margin: ${rem("0px")} auto;
  `}
`;

const Card = ({ children, type }) => {
  return <CardContainer type={type}>{children}</CardContainer>;
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
};

Card.defaultProps = {
  type: "other",
};

export default Card;
